<template>
	<div style="width: 100%; display: flex; justify-content: center; align-items: center">
		<iframe ref="iframe" :src="yearEndPosterUrl" class="iframe" style="width: 20vw; height: 38vw; border: none" />
	</div>
</template>

<script>
import {getYearReportUrl} from '@/util/welHintUtil'

export default {
	name: 'newYearReportModal',
	data() {
		return {
			yearEndPosterUrl: '',
		}
	},
	created() {
		this.yearEndPosterUrl = getYearReportUrl()
		console.log(999, this.yearEndPosterUrl)
	},
	mounted() {},
	beforeDestroy() {},
	methods: {},
}
</script>

<style lang="less" scoped>
.ys-float-btn {
	// background:rgb(255,255,255);
	// box-shadow:0 2px 10px 0 rgba(0,0,0,0.1);
	border-radius: 50%;
	// color: #666666;
	z-index: 20;
	transition: all 0.3s;

	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	position: fixed;
	bottom: 20vw;

	// img{
	//   width: 50%;
	//   height: 50%;
	//   object-fit: contain;
	//   margin-bottom: 3px;
	// }

	// p{
	//   font-size:7px;
	// }
}
</style>
